export default __webpack_public_path__ + "static/media/buzzer-pressed-red.99fe8ab7.png";